import React, { useState, useEffect, Fragment } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "../../components/Card/Card";
import CardHeader from "../../components/Card/CardHeader";
import CardBody from "../../components/Card/CardBody";
import Grid from "@material-ui/core/Grid";
import { getRequest } from "../../api/Api";
import Loader from "components/Loader/Loader";
import CurrentMedicationForm from "../../components/Forms/CurrentMedication";
import EditIcon from "@material-ui/icons/Edit";
import { Typography } from "@material-ui/core";

import {
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";

const styles = (theme) => ({
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
  },
  icon: {
    cursor: "pointer",
  },
  fab: {
    margin: 2,
    backgroundColor: "#66a668",
    width: 50,
    height: 42,
  },
  table: {
    minWidth: 320,
  },
});

const useStyles = makeStyles(styles);

const CurrentMedicationVerticalTable = (props) => {
  const classes = useStyles();
  const { patient } = props;
  const [currentmedicationList, setCurrentMedicationList] = useState([]);
  const [showCurrentMedicationForm, setShowCurrentMedicationForm] = useState(
    false
  );
  const [currentMedicationCount, setCurrentMedicationCount] = useState();

  const fetchPatientCurrentMedicationById = () => {
    const endPoint = "get_patient_current_medications_by_visit_id";
    const token = "Bearer " + localStorage.getItem("jwt");
    let param = [patient.patient.attributes.id, patient.visitId];
    getRequest(endPoint, token, param).then((data) => {
      if (data.error) {
        console.log(data.error);
      } else {
        setCurrentMedicationList(data.data);
      }
    });
  };
  useEffect(() => {
    if(!showCurrentMedicationForm){
    fetchPatientCurrentMedicationById();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showCurrentMedicationForm]);

  useEffect(() => {
    if (patient.patientInfo) {
      if (
        patient.patientInfo.attributes.flagged_count.current_medications > 0
      ) {
        setCurrentMedicationCount(
          patient.patientInfo.attributes.flagged_count.current_medications
        );
      } else {
        setCurrentMedicationCount(0);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [patient.patientInfo]);

  return (
    <Fragment>
      <div className={classes.root}>
        <Grid>
          <Grid item xs={12} sm={12} md={12}>
            {showCurrentMedicationForm ? (
              <CurrentMedicationForm
                patient={patient.patient}
                vitalLength={patient.vitalLength}
                medicalProblemLength={patient.medicalProblemLength}
                correctionCountHandler={patient.correctionCountHandler}
                setShowCurrentMedicationForm={(value) =>
                  setShowCurrentMedicationForm(value)
                }
                isReviewOnly={patient.isReviewOnly}
              />
            ) : (
              <Card
                style={{
                  boxShadow:
                    "0 2px 8px rgba(0,0,0,0.30), 0 10px 12px rgba(0,0,0,0.22)",
                }}
                data-testid={`currentmedication-detail-card`}
              >
                <CardHeader
                  style={{ width: "105px", marginTop: 0, marginLeft: 0 }}
                  color="success"
                >
                  <h4 className={classes.cardTitleWhite}>Current Medication</h4>
                </CardHeader>
                {patient.patient.attributes.last_visit.is_sent_for_review ===
                  0 &&
                patient.patient.attributes.last_visit
                  .is_sent_to_patient_pool === 0 ? (
                  <Grid
                    item
                    container
                    justify="flex-end"
                    xs={12}
                    sm={12}
                    md={12}
                  >
                    <EditIcon
                      data-testid="currentmedication-edit-icon"
                      onClick={() => setShowCurrentMedicationForm(true)}
                    />
                  </Grid>
                ) : null}
                <CardBody>
                  {currentMedicationCount > 0 ? (
                    <Typography
                      align="center"
                      style={{ color: "red", fontSize: 15, fontWeight: 500 }}
                    >
                      Correction required
                    </Typography>
                  ) : null}
                  <TableContainer className={classes.container}>
                    <Table stickyHeader aria-label="sticky table">
                      <TableHead>
                        <TableRow>
                          <TableCell style={{ backgroundColor: "white" }}>
                            Drug Name
                          </TableCell>
                          <TableCell style={{ backgroundColor: "white" }}>
                            Drug Type/Frequency
                          </TableCell>
                          <TableCell
                            style={{
                              backgroundColor: "white",
                            }}
                          >
                            Duration
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {currentmedicationList.map((current) => (
                          <TableRow hover key={current.attributes.id}>
                            <TableCell>
                              {current.attributes.drug_name}(
                              {current.attributes.strength} mg)
                            </TableCell>
                            {current.attributes.drug_type === null &&
                            current.attributes.frequency === null ? (
                              <TableCell></TableCell>
                            ) : (
                              <TableCell>
                                {current.attributes.drug_type !== null
                                  ? current.attributes.drug_type.value
                                  : ""}
                                /
                                {current.attributes.frequency !== null
                                  ? current.attributes.frequency.acronym
                                  : ""}
                              </TableCell>
                            )}
                            <TableCell>{current.attributes.duration}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </CardBody>
              </Card>
            )}
          </Grid>
        </Grid>
      </div>
    </Fragment>
  );
};

export default CurrentMedicationVerticalTable;
